<template>
    <div class="notes" ref="main">
        <a class="note" v-for="n in 10" @click="handleClick" :style="`color: ${getRandomColor()};`">

<!--                <img src="/images/debug/arrow.png" style="width:100px; height: 100px;" />-->
            <svg v-if="n % 2" viewBox="0 0 101 124" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="currentColor" stroke="black" stroke-width="0"
                    d="M95.4511 31.9L96.3974 26.2988L90.969 27.9723C89.7526 28.3472 88.48 28.6542 87.1447 28.9082C84.1453 29.3436 81.4191 28.91 78.8197 27.6111L78.8118 27.6072C62.6951 19.6044 46.3329 12.6284 29.6824 6.7026L26.0576 5.41257L25.1154 9.1429C19.0966 32.9725 22.4436 55.7884 35.0441 77.4295C28.7919 77.2551 23.1922 78.523 18.3927 81.429C11.957 85.3257 7.46849 91.8599 4.67053 100.492L4.46041 101.14L4.50886 101.82C4.93767 107.836 6.85192 112.873 10.795 116.247C14.7151 119.601 20.0293 120.787 26.139 120.442C34.6761 120.058 41.946 116.787 47.7208 110.66C51.8266 106.308 54.4049 101.625 54.8922 96.6212C55.3764 91.6487 53.7448 86.8893 50.4758 82.4494C44.8881 71.8537 40.4165 60.8753 37.0474 49.511C49.0314 53.9449 61.3726 54.8415 74.0242 52.1833L74.0284 52.1824C79.9055 50.9401 84.8247 48.6869 88.5286 45.2324C92.2688 41.7442 94.5498 37.2345 95.4511 31.9Z"
                />
            </svg>
            <svg v-else width="122" height="148" viewBox="0 0 122 148" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="currentColor" stroke="black" stroke-width="0"
                    d="M25.1513 12.9634C20.9554 38.0547 25.239 61.8621 37.9535 84.2642C30.6966 83.9135 24.2379 85.3187 18.7492 88.7054C11.689 93.0618 6.75128 100.378 3.66425 110.096L3.5 110.613V111.156C3.5 114.937 4.4196 118.492 6.24501 121.789L6.2466 121.792C8.56521 125.971 11.6748 129.136 15.6421 131.031C19.593 132.918 24.0964 133.403 28.978 132.743L28.9901 132.741C37.7966 131.518 45.2318 127.601 51.1265 121.037C55.5667 116.128 58.293 110.917 58.7902 105.419C59.2847 99.951 57.5304 94.6909 53.9607 89.7372C47.5754 77.5232 42.5198 64.8455 38.8068 51.669L85.356 62.8498C88.3225 74.2269 92.4646 85.133 97.7935 95.5514C92.4297 95.3803 87.4228 96.2545 82.8306 98.2527C77.1618 100.719 72.33 104.809 68.3079 110.357L68.3064 110.36C65.8574 113.743 64.3453 117.358 63.9473 121.188C63.5491 125.021 64.29 128.847 66.0118 132.614L66.0158 132.622C67.9044 136.724 70.6004 139.947 74.208 142.005C77.8058 144.057 82.0051 144.776 86.6092 144.407L86.6241 144.406L86.6391 144.405C96.5116 143.529 104.778 139.37 111.247 131.935C115.48 127.078 118.046 121.945 118.445 116.56C118.845 111.177 117.044 106.031 113.475 101.213C99.059 77.9103 93.4432 53.3095 96.5086 27.2709L97.2753 21.2978L97.6444 18.4225L94.8882 17.5244C74.5437 10.8949 53.4296 6.56805 31.6 4.51537L29.8533 4.35112L28.6765 5.6524C26.7857 7.74315 25.5973 10.2204 25.1513 12.9634Z"
                />
            </svg>

        </a>
        <div id="guide"></div>
    </div>
</template>

<script>

    import { onMounted, onUnmounted, ref } from 'vue';
    import gsap from 'gsap';
    import {useMainStore}                  from "../stores/main";
    import { storeToRefs }      from "pinia";
    import Boid from "../game/movement/Boid";

    export default {
        setup()
        {
            const main = ref();
            let ctx;

            let store = useMainStore();

            const { addToScore } = store;

            // change params to alter difficulty
            const move = 100; // max move length
            const speed = 0.5; // max move length

            // get random color, but from a palette
            function getRandomColor() {
                const arr = ['#FFE598', '#F1EDD7', '#FFD2A3', '#A1FFC3', '#F0EBD3', '#FFC76C'];
                return arr[(Math.floor(Math.random() * arr.length))];
                // return '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
            }

            function handleClick(e)
            {
                addToScore(1);
                e.target.remove();
            }

            // start with notes just about everywhere
            function disperse(el) {
                gsap.to(el, {
                    x: () => {
                        const random = gsap.utils.random(0, window.innerWidth);
                        return (window.innerWidth - random);
                    },
                    y: () => {
                        const random = gsap.utils.random(window.innerHeight * -0.25, window.innerHeight * 0.25);
                        return ((window.innerHeight * 0.5) + random);
                    },
                    duration: 0,
                    ease: "none"
                })
            }

            // move along
            function wander(el) {
                gsap.to(el, {
                    x: () => {
                        var p = el.getBoundingClientRect();
                        var w = el.offsetWidth;
                        const random = gsap.utils.random(move * -1, move);

                        if(random >= 0) {
                            // if the movement would bring the note too close to the right side of the screen, move to the left instead
                            return (p.left + random <= window.innerWidth - w)? p.left + random : p.left - random;
                        } else {
                            // if the movement would bring the note too close to the left side of the screen, move to the right instead
                            return (p.left + random >= w)? p.left + random : p.left - random;
                        }
                    },
                    y: () => {
                        var p = el.getBoundingClientRect();
                        var h = el.offsetHeight;
                        const random = gsap.utils.random(move * -1, move);

                        if(random >= 0) {
                            // if the movement would bring the note too close to the bottom side of the screen, move to the top instead
                            return (p.top + random <= window.innerHeight - h)? p.top + random : p.top - random;
                        } else {
                            // if the movement would bring the note too close to the top side of the screen, move to the bottom instead
                            return (p.top + random >= h)? p.top + random : p.top - random;
                        }
                    },
                    duration: speed,
                    ease: "none",
                    onComplete: () => wander(el)
                });
            }

            function animate ()
            {
                requestAnimationFrame(animate);

                for (let i = 0; i < boids.length; i++)
                {
                    boids[i].update(boids);
                }
            }


            let boids = [];
            let arrNoise = [];

            onMounted(() => {
                // ctx = gsap.context((self) => {
                //     let notes = self.selector('.note');
                //
                //     notes.forEach(disperse);
                //     notes.forEach(wander);
                //
                // }, main.value);

                let notes = document.querySelectorAll('.note');

                let guide = document.querySelector("#guide");
                guide.width = window.innerWidth;
                guide.height = window.innerHeight;




                let last = null;
                for (let i = 0; i < notes.length; i++)
                {
                    arrNoise.push(new SimplexNoise());
                    const x = (Math.random() * window.innerWidth) >> 0;
                    const y = 200 + ((Math.random() * window.innerHeight - 200) >> 0);

                    let boid = new Boid(x,y, notes[i], i);
                    last = boid;

                    boids.push (boid);
                }

                //Boid.showInCanvas(guide, last.getNoise());

                animate();


            });

            onUnmounted(() => {
                //ctx.revert(); // Cleanup
            });

            return { getRandomColor, handleClick, main };
        }
    };
</script>
